////////////////////////////////////
//  MV Slider
////////////////////////////////////

function mvSlider(){
  $('.js-mvSlider').slick({
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding:"28%",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerPadding:"8%",
        },
      },
    ],
  });
}

////////////////////////////////////
//  Item Slider
////////////////////////////////////

function itemSlider(){
  function sliderSetting(){
  
      var width = $(window).width();
  
      if(width > 767){
          $('.js-itemSlider').not('.slick-initialized').slick({
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
              autoplay: true,
              autoplaySpeed: 3000,
              centerMode: true,
              variableWidth: true,
          });
      } else {
          $('.slide.slick-initialized').slick('unslick');
      }
  }
  
  sliderSetting();
  
  $(window).resize( function() {
      sliderSetting();
  });
  
}

////////////////////////////////////
//  Item Slider02
////////////////////////////////////

function itemSlider02() {
  const prevUrl = "//hoshiiro-ec.myshopify.com/cdn/shop/t/9/assets/slider-arrow-l.svg";
  const nextUrl = "//hoshiiro-ec.myshopify.com/cdn/shop/t/9/assets/slider-arrow-r.svg";

  $('.js-itemSlider02').each(function () {
    const $slider = $(this);
    const slideCount = $slider.find('li').length;

    function sliderSetting() {

      // スライド数が4以下なら slick を使わない
      if (slideCount <= 4) {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
        return;
      }

      // slick 初期化（初期化済みは除外）
      $slider.not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        variableWidth: false,
        prevArrow:
          '<button class="slick-prev"><img src=' +
          prevUrl +
          ' alt="prev"></button>',
        nextArrow:
          '<button class="slick-next"><img src=' +
          nextUrl +
          ' alt="next"></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }

    // 初期実行
    sliderSetting();

    // リサイズ対応
    $(window).on('resize', function () {
      sliderSetting();
    });
  });
}

$(function(){
    itemSlider();
    itemSlider02();
    mvSlider();
});
